import React, { useEffect, useState } from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemIcon from '@mui/material/ListItemIcon';
import { StatusTag } from '../../components/StatusTag/StatusTag';
import { Status } from '../../types/site';
import EditIcon from '@mui/icons-material/Edit';
import { ContentContainer } from '../ContentContainer';
import { isDataLoaded} from '../../types';
import { useDeviceDetails } from '../../data/DataProviders/DeviceDetailsProvider';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import { Actions, Thunks } from '../../actions';
import { SierraChildDeviceData } from '../../types/device';
import deviceStyles from '../../app/device-management/DeviceStyle';
import { NavigationHeader } from '../NavigationHeader/NavigationHeader';
import { Grid } from '@mui/material';
import { LabelWithSubTitle } from '../LabelWithSubTitle/LabelWithSubtitle';
import { pushAppRoute } from '../../data/domain/route-manager';
import { useHistory } from 'react-router-dom';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { AppRoute } from '../../routes';
import { FX30_ETHERNET } from '../../constants';
import { DeleteForever } from '@mui/icons-material';
import { useToasts } from '../../data/DataProviders/ToastProvider';
import { DeleteConfirmModal } from '../CommonDeleteModals/DeleteConfirmModal';
// import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { Selectors } from '../../selectors';
import { useSignalRSiteData } from '../../data/DataProviders/SignalRSiteDataProvider';
import _ from 'lodash';

export const ChildDeviceProfileData: React.FC<{
    sierraChildDeviceDetails: SierraChildDeviceData | null;
    backAppRoute: AppRoute;
}> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const currentAppRoute = useCurrentAppRoute();
    const classes = deviceStyles();
    const deviceDetails = useDeviceDetails();
    const { addToast } = useToasts();
    const [unmodifiedChildDeviceInfo, setUnmodifiedChildDeviceInfo] = useState<SierraChildDeviceData | null>(null);
    const [modifiedChildDeviceInfo, setModifiedChildDeviceInfo] = useState<SierraChildDeviceData | null>(null);
    const [openDelete, setOpenDelete] = React.useState(false);
    // const [deleteText, setDeleteText] = React.useState('');
   // const { t } = useLanguageLocale();
    const authHelper = useAuthHelper();
    const deviceId = (props.sierraChildDeviceDetails && props.sierraChildDeviceDetails.pxWhiteDeviceId) || '';
    const childDeviceState = useSelector(Selectors.SierraDevice.deviceRegistration);

    const realTimeSiteData = useSignalRSiteData();
    const [deviceStatus, setDeviceStatus] = React.useState<boolean | null>();

    React.useEffect(() => { 
        if (isDataLoaded(deviceDetails)) {
             setDeviceStatus(deviceDetails.value.status);
        }
    }, [deviceDetails]);    

    React.useEffect(() => { 
         if (realTimeSiteData && realTimeSiteData.devices) {
             if (isDataLoaded(deviceDetails)) {
                 const updatedDeviceStatus =  _.find(realTimeSiteData.devices, {
                    deviceId: deviceDetails.value.id 
                });
                if(updatedDeviceStatus){
                  setDeviceStatus(updatedDeviceStatus.status);
                }
                
            }   
         }  

    }, [realTimeSiteData]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        dispatch(Actions.SierraDevices.sierraChildDeviceRegistrationUnmounted());
    }, []); //eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (props.sierraChildDeviceDetails) {
            setUnmodifiedChildDeviceInfo(props.sierraChildDeviceDetails);
            setModifiedChildDeviceInfo(props.sierraChildDeviceDetails);
        }
    }, [props.sierraChildDeviceDetails]);

    

    // useEffect(() => {
    //     if (!childDeviceState.deleteChildDeviceLoading && childDeviceState.deleteChildDeviceSuccess) {
    //         addToast('Device deleted successfully.');
    //         // pushAppRoute(history, props.appRoute);
    //     }
    // }, [childDeviceState.deleteChildDeviceLoading, childDeviceState.deleteChildDeviceSuccess]); //eslint-disable-line react-hooks/exhaustive-deps

    const navigateToEditDevice = (): void => {
        if (currentAppRoute.type === 'ChildDeviceProfile')
            pushAppRoute(history, {
                type: 'EditDeviceProfile',
                deviceId: currentAppRoute.deviceId,
                locationId: currentAppRoute.locationId,
                orgId: currentAppRoute.orgId,
                siteId: currentAppRoute.siteId,
                childDeviceId: currentAppRoute.childDeviceId,
            });
    };

    const navigateToConnectedDeviceProfile = (): void => {
        if (currentAppRoute.type === 'ChildDeviceProfile')
            pushAppRoute(history, {
                type: 'DeviceProfile',
                deviceId: currentAppRoute.deviceId,
                locationId: currentAppRoute.locationId,
                orgId: currentAppRoute.orgId,
                siteId: currentAppRoute.siteId,
            });
            dispatch(Actions.SierraDevices.sierraChildDeviceRegistrationUnmounted());
    };

    useEffect(() => {
        if (childDeviceState.deleteChildDeviceSuccess) {
           
            if(props.sierraChildDeviceDetails && props.sierraChildDeviceDetails.name)
            addToast(`${props.sierraChildDeviceDetails.name} deleted successfully`);
            navigateToConnectedDeviceProfile();
        }
    }, [childDeviceState.deleteChildDeviceSuccess]);

    const onDelete = (): void => {
        dispatch(Thunks.SierraDevice.deleteChildDevice(deviceId, addToast, authHelper));
        setOpenDelete(false);
        // setDeleteText('');
    };

    const validateDelete = (): void => {
        setOpenDelete(true);
    };

    const closePopUp = (): void => {
        setOpenDelete(false);
    };

    // const isDisable = (): boolean => (deleteText.length ? deleteText !== 'delete' : true);

    return (
        <>
            {isDataLoaded(deviceDetails) && unmodifiedChildDeviceInfo && modifiedChildDeviceInfo && (
                <>
                    <NavigationHeader
                        siteName={deviceDetails.value.siteName}
                        for="device"
                        connectedDevice={modifiedChildDeviceInfo.parentGatewayName || ''}
                        device={modifiedChildDeviceInfo.name}
                    />
                    <ContentContainer>
                        <Paper>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}>
                                    <Box>
                                        <List>
                                            <ListItem data-testid="child-device-name">
                                                <Box  width={400} >
                                                <Typography variant="h6" color="primary" style={{ wordWrap: "break-word" }}>
                                                    {unmodifiedChildDeviceInfo.name}
                                                </Typography>
                                                </Box>

                                                <ListItemSecondaryAction>
                                                    <ListItemIcon
                                                        data-testid="device-status-icon"
                                                        style={{ display: 'block'}}

                                                    >
                                                        {deviceStatus ? (
                                                            <StatusTag
                                                                status={Status.Online}
                                                                style={{ marginRight: 30 }}
                                                            />
                                                        ) : (
                                                            <StatusTag
                                                                status={Status.Offline}
                                                                style={{ marginRight: 30 }}
                                                            />
                                                        )}
                                                    </ListItemIcon>
                                                </ListItemSecondaryAction>
                                            </ListItem>
                                            <ListItem data-testid="device-model" className={classes.margin8}>
                                                <LabelWithSubTitle
                                                    title={unmodifiedChildDeviceInfo.model}
                                                    subTitle={'Supported Device Type'}
                                                />
                                            </ListItem>
                                            {unmodifiedChildDeviceInfo.parentModelType?.toLowerCase() ===
                                                FX30_ETHERNET && (
                                                <ListItem data-testid="ip-address" className={classes.margin8}>
                                                    <LabelWithSubTitle
                                                        title={unmodifiedChildDeviceInfo.ipAddress}
                                                        subTitle={'Modbus (TCP/IP) Address'}
                                                    />
                                                </ListItem>
                                            )}
                                            <ListItem data-testid="rtu-address" className={classes.margin8}>
                                                <LabelWithSubTitle
                                                    title={unmodifiedChildDeviceInfo.unitId}
                                                    subTitle={
                                                        unmodifiedChildDeviceInfo.parentModelType?.toLowerCase() ===
                                                        FX30_ETHERNET
                                                            ? 'Unit ID'
                                                            : 'RTU Server Address'
                                                    }
                                                />
                                            </ListItem>
                                            {unmodifiedChildDeviceInfo.parentModelType?.toLowerCase() ===
                                                FX30_ETHERNET && (
                                                <ListItem data-testid="ip-port" className={classes.margin8}>
                                                    <LabelWithSubTitle
                                                        title={unmodifiedChildDeviceInfo.ipPort}
                                                        subTitle={'IP Port'}
                                                    />
                                                </ListItem>
                                            )}
                                        </List>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <List>
                                            <ListItem data-testid="device-details">
                                                <Button
                                                    style={{ marginRight: 15, width: 300 }}
                                                    variant="contained"
                                                    color="primary"
                                                    startIcon={<EditIcon />}
                                                    data-testid="edit-action"
                                                    onClick={(): void => {
                                                        navigateToEditDevice();
                                                    }}
                                                >
                                                    Edit Device
                                                </Button>
                                            </ListItem>
                                            <ListItem>
                                                <Button
                                                    style={{
                                                        width: 300,
                                                        color: PXBColors.red[500],
                                                        borderColor: PXBColors.gray[100],
                                                    }}
                                                    startIcon={<DeleteForever />}
                                                    variant="outlined"
                                                    color="inherit"
                                                    data-testid="delete-action"
                                                    onClick={(): void => {
                                                        validateDelete();
                                                    }}
                                                >
                                                    Delete Forever
                                                </Button>
                                            </ListItem>
                                        </List>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Paper>

                           { props.sierraChildDeviceDetails && 
                                  <DeleteConfirmModal
                                    open={openDelete}
                                    onClose={closePopUp}
                                    name={ props.sierraChildDeviceDetails.name }
                                    handleDelete={onDelete}
                                    navigateFn={navigateToConnectedDeviceProfile}
                                  />
                            }

                    </ContentContainer>
                </>
            )}
        </>
    );
};
